// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__AMHxr","container":"styles_container__2Xv89","title":"styles_title__20bTd","wrapper":"styles_wrapper__1lyvU","answer":"styles_answer__2qX1t"};